var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1925 6.64156V1.62891C12.1925 1.09592 12.6176 0.651764 13.1553 0.651764C13.6367 0.651764 14.0445 1.02498 14.1091 1.49772L14.118 1.62891V6.64156L20.0946 6.64194C23.0704 6.64194 25.5152 9.0788 25.6525 12.1179L25.6586 12.3876V18.6884C25.6586 21.7489 23.2988 24.261 20.3672 24.402L20.1071 24.4083H6.20325C3.22744 24.4083 0.794385 21.9836 0.657782 18.9333L0.651733 18.6626V12.3747C0.651733 9.31427 2.99976 6.78996 5.93067 6.64822L6.19075 6.64194H12.1924V14.6471L10.1918 12.5813C9.81674 12.1939 9.20408 12.1939 8.82897 12.5813C8.64142 12.7749 8.5539 13.0332 8.5539 13.2914C8.5539 13.4877 8.60991 13.6922 8.72835 13.8653L8.82897 13.9886L12.4675 17.7588C12.6425 17.9525 12.8926 18.0558 13.1552 18.0558C13.3635 18.0558 13.5719 17.984 13.7369 17.8481L13.8303 17.7588L17.4688 13.9886C17.8439 13.6013 17.8439 12.9686 17.4688 12.5813C17.1278 12.2291 16.5905 12.1971 16.2138 12.4852L16.106 12.5813L14.1179 14.6471V6.64194L12.1925 6.64156Z",
    fill: "#2F4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBox);
export default __webpack_public_path__ + "static/media/Arrow-Down-Box.46fae8e2c9b3b0d8ca1354775a332ce6.svg";
export { ForwardRef as ReactComponent };